document.addEventListener('DOMContentLoaded', () => {
  const setLangClass = () => {
    const lang = document.documentElement.lang || '';

    document.body.classList.toggle('is-en', lang.startsWith('en'));
    document.body.classList.toggle('is-ja', lang.startsWith('ja'));
  };

  setLangClass();

  const observer = new MutationObserver(setLangClass);
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['lang'],
  });
});